<header>
  <img [src]="tenantConfigService.brandAssetUrl('/assets/icons/chatbot/lily.svg')" alt="Lily chatbot icon" aria-details="Lily image" />
  <h2>Hi, my name is Lily,<br />how can I help you today?</h2>
</header>
<div class="sample-responses-container">
  <div class="sample-responses-container_wrap">
    <div class="neutral-chat-bubble">
      <span>How many buy-to-let mortgages were completed in the last 6 months?</span>
    </div>
    <div class="neutral-chat-bubble">
      <span>How many mortgage completions did we have this month?</span>
    </div>
  </div>
  <div>
    <div class="neutral-chat-bubble">
      <span>Which advisers had the highest appointment attendance this month?</span>
    </div>
  </div>
</div>
